
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Code, Preview } from "@lighting-beetle/lighter-styleguide";
import { Grid, GridCol } from "./../components";
import "./../styles/base/styleguide.scss";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Flex alignment utilities`}</h1>
    <p>{`Alignment classes are used to position children of flexbox containers.`}</p>
    <h2>{`Horizontal alignment`}</h2>
    <Preview hasCodePreview={false} mdxType="Preview">
  <Code mdxType="Code">.align-items-right</Code>
  <Grid className="align-items-right" mdxType="Grid">
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Code mdxType="Code">.align-items-center</Code>
  <Grid className="align-items-center" mdxType="Grid">
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Code mdxType="Code">.align-items-spaced</Code>
  <Grid className="align-items-spaced" mdxType="Grid">
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Code mdxType="Code">.align-items-justify</Code>
  <Grid className="align-items-justify" mdxType="Grid">
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
    <GridCol size={3} mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Grid mdxType="Grid">
    <GridCol size={3} className="align-self-left" mdxType="GridCol">
      <div className="l-debug">
        <Code mdxType="Code">.align-self-left</Code>
      </div>
    </GridCol>
  </Grid>
  <Grid mdxType="Grid">
    <GridCol size={3} className="align-self-center" mdxType="GridCol">
      <div className="l-debug">
        <Code mdxType="Code">.align-self-center</Code>
      </div>
    </GridCol>
  </Grid>
  <Grid mdxType="Grid">
    <GridCol size={3} className="align-self-right" mdxType="GridCol">
      <div className="l-debug">
        <Code mdxType="Code">.align-self-right</Code>
      </div>
    </GridCol>
  </Grid>
    </Preview>
    <h2>{`Vertical alignment`}</h2>
    <Preview hasCodePreview={false} mdxType="Preview">
  <Code mdxType="Code">Default</Code>
  <Grid mdxType="Grid">
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        Nulla vitae elit libero, a pharetra augue. Donec sed odio dui.
      </div>
    </GridCol>
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Code mdxType="Code">.align-items-top</Code>
  <Grid className="align-items-top" mdxType="Grid">
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        Nulla vitae elit libero, a pharetra augue. Donec sed odio dui.
      </div>
    </GridCol>
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Code mdxType="Code">.align-items-middle</Code>
  <Grid className="align-items-middle" mdxType="Grid">
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        Nulla vitae elit libero, a pharetra augue. Donec sed odio dui.
      </div>
    </GridCol>
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Code mdxType="Code">.align-items-bottom</Code>
  <Grid className="align-items-bottom" mdxType="Grid">
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        Nulla vitae elit libero, a pharetra augue. Donec sed odio dui.
      </div>
    </GridCol>
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">Lorem ipsum</div>
    </GridCol>
  </Grid>
  <hr />
  <Grid mdxType="Grid">
    <GridCol size={3} className="l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        Nulla vitae elit libero, a pharetra augue. Donec sed odio dui.
      </div>
    </GridCol>
    <GridCol size={3} className="align-self-top l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        <Code mdxType="Code">.align-self-top</Code>
      </div>
    </GridCol>
    <GridCol size={3} className="align-self-middle l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        <Code mdxType="Code">.align-self-middle</Code>
      </div>
    </GridCol>
    <GridCol size={3} className="align-self-bottom l-debug-flex" mdxType="GridCol">
      <div className="l-debug">
        <Code mdxType="Code">.align-self-bottom</Code>
      </div>
    </GridCol>
  </Grid>
    </Preview>
`;
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;